import { INewTranslationSettings } from '@/shared/interfaces/new-translation-settings';

export const newPhotoTranslationSettings = (clientId: number): INewTranslationSettings => ({
  clientId,
  model: 'photos',
  keys: ['name', 'alt_text'],
});

export const newUnitFloorplanTranslationSettings = (clientId: number): INewTranslationSettings => ({
  clientId,
  model: 'suite_type_floorplans',
  keys: ['name', 'description'],
});
